import { createIcon } from '@chakra-ui/icons'

export const MarkerIcon = createIcon({
  displayName: 'MarkerIcon',
  viewBox: '0 0 12 12',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.54253 10.8028C7.63573 9.90735 10 7.68166 10 5.18136C10 4.07239 9.57857 3.00885 8.82843 2.22469C8.07828 1.44053 7.06087 1 6 1C4.93913 1 3.92172 1.44053 3.17157 2.22469C2.42143 3.00885 2 4.07239 2 5.18136C2 7.68166 4.36427 9.90735 5.45747 10.8028C5.77841 11.0657 6.22159 11.0657 6.54253 10.8028ZM5 5.08844C5 4.52394 5.44772 4.06633 6 4.06633C6.55228 4.06633 7 4.52394 7 5.08844C7 5.65294 6.55228 6.11055 6 6.11055C5.44772 6.11055 5 5.65294 5 5.08844Z"
    />
  ),
})
